import { Dispatch, SetStateAction } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import { Box } from '@mui/material';
import { EnumService, mapService } from 'tdc-web-backend/enums/enums';
import { ReactComponent as SuitcaseCheckIcon } from '../../../../../../../assets/icons/layout-icons/SuitcaseCheckIcon.svg';
import ConfirmModal from '../../../../../../../components/confirm-modal/ConfirmModal';
import { primaryLight } from '../../../../../../../utils/color';
import CustomInput from '../../../../../../../components/custom-input/CustomInput';
import useUpdate from '../../../../../../../utils/hooks/crud-hooks/useUpdate';
import { useSellerHomescreenContext } from '../../../SellerHomescreenContext';
import { useRefresh } from '../../../../../../../utils/hooks/crud-hooks/useRefresh';

interface CompanyTechLanguagesEditModalProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyServicesEditModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTechLanguagesEditModalProps) => {
  const { companyData } = useSellerHomescreenContext();
  const refresh = useRefresh();

  const formMethods = useForm<Pick<CompanyDto, 'services'>>({
    defaultValues: {
      services: companyData?.services ?? ([] as EnumService[]),
    },
    mode: 'onChange',
  });

  const { handleSubmit, getValues } = formMethods;

  const { mutate: update, isLoading } = useUpdate<CompanyDto, Partial<CompanyDto>>({
    resource: 'companies',
  });

  const onSubmit = () => {
    update(
      {
        id: companyData?.id as CompanyDto['id'],
        data: { services: getValues('services') },
      },
      {
        onSuccess: () => {
          refresh();
          setIsEditModalOpen(false);
        },
      },
    );
  };

  return (
    <ConfirmModal
      width="40%"
      isModalOpen={isEditModalOpen}
      setIsModalOpen={setIsEditModalOpen}
      title="Services"
      onCancel={() => setIsEditModalOpen(false)}
      automaticallyCloseModalOnButtonClick={false}
      isLoading={isLoading}
      onConfirm={handleSubmit(onSubmit)}
      confirmButtonText="Save"
      message={
        <FormProvider {...formMethods}>
          <Box component="form">
            <CustomInput
              required
              input={<CustomInput.Autocomplete />}
              choices={mapService}
              name="services"
              label="Services"
              multiple
              placeholder="Select offered services"
              sx={{ width: '100%' }}
            />
          </Box>
        </FormProvider>
      }
      iconProps={{
        icon: <SuitcaseCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: primaryLight[100],
      }}
    />
  );
};

export default CompanyServicesEditModal;
